import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import {
  LanguageState,
  UserPreferencesActions,
  UserPreferencesState,
} from '@osos/shared/legacy-core';
import { MenuMode, SidebarVisibility } from '@osos/shared/types';
import { PrimeNG } from 'primeng/config';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { MenuService } from '../../services/menu.service';
import { BaseUiThemeDirective } from '../base/base.directive';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class MainComponent
  extends BaseUiThemeDirective
  implements AfterViewInit, OnInit, OnDestroy
{
  topbarMenuActive: boolean;
  menuActive: boolean;
  @Input() clickHamburger: boolean;
  @ViewChild('appDrawer') appDrawer: ElementRef;

  staticMenuDesktopInactive: boolean;

  mobileMenuActive: boolean;

  menuClick: boolean;

  mobileTopbarActive: boolean;

  topbarRightClick: boolean;

  topbarItemClick: boolean;

  activeTopbarItem: string;

  documentClickListener: () => void;

  configActive: boolean;

  configClick: boolean;

  rightMenuActive: boolean;

  menuHoverActive = true;

  searchClick = false;

  search = false;

  currentInlineMenuKey: string;

  inlineMenuActive: any[] = [];

  inlineMenuClick: boolean;

  ripple = true;
  contentOnly = false;
  inputStyle: 'filled' | 'outlined' = 'filled';

  rtlDir$: Observable<boolean> = this.store
    .select(LanguageState.currentLanguageRTLDirection)
    .pipe(tap((rtl) => (this._rtlDir = rtl)));
  private _rtlDir: boolean;

  menuModeEnum = MenuMode;
  constructor(
    public renderer: Renderer2,
    private menuService: MenuService,
    private primengConfig: PrimeNG,
    public store: Store,
    private activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    this.primengConfig.ripple.set(true);

    this.menuActive = this.isMenuShouldOpened();
    this.store
      .select(UserPreferencesState.userPreferences)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.menuMode = res?.menuMode;
        this.layoutMode = res?.layoutMode;
        // this.theme = res?.theme;
        this.fontScale = res?.fontSize;
        this.inputStyle = this.layoutMode === 'dark' ? 'filled' : 'outlined';
      });

    this._subscribeToViewSideBarMode();
    this.checkQueryParam();
  }

  isMenuShouldOpened(): boolean {
    return (
      (this.isSlim() || this.isIcons() || this.isStatic()) && !this.isMobile()
    );
  }

  ngAfterViewInit(): void {
    // hides the horizontal submenus or top menu if outside is clicked
    this.documentClickListener = this.renderer.listen('body', 'click', () => {
      if (!this.topbarItemClick) {
        this.activeTopbarItem = null;
        this.topbarMenuActive = false;
      }

      if (!this.menuClick && (this.isHorizontal() || this.isSlim())) {
        this.menuService.reset();
      }

      if (this.configActive && !this.configClick) {
        this.configActive = false;
      }

      if (!this.menuClick) {
        if (this.mobileMenuActive) {
          this.mobileMenuActive = false;
        }
        if (this.isOverlay()) {
          this.menuActive = false;
        }

        this.menuHoverActive = false;
        this.unblockBodyScroll();
      }

      if (!this.searchClick) {
        this.search = false;
      }

      if (
        this.inlineMenuActive[this.currentInlineMenuKey] &&
        !this.inlineMenuClick
      ) {
        this.inlineMenuActive[this.currentInlineMenuKey] = false;
      }

      this.inlineMenuClick = false;
      this.searchClick = false;
      this.configClick = false;
      this.topbarItemClick = false;
      this.topbarRightClick = false;
      this.menuClick = false;
    });
  }

  onMenuButtonClick(event: any): void {
    this.menuActive = !this.menuActive;
    this.topbarMenuActive = false;
    this.topbarRightClick = true;
    this.menuClick = true;

    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
      this.mobileMenuActive = !this.mobileMenuActive;
      if (this.mobileMenuActive) {
        this.blockBodyScroll();
      } else {
        this.unblockBodyScroll();
      }
    }
    const visibility = this.menuActive
      ? SidebarVisibility.Open
      : SidebarVisibility.Close;
    this.store.dispatch(
      new UserPreferencesActions.UpdateSidebarVisibility(visibility),
    );
    event.preventDefault();
  }

  onTopbarMobileButtonClick(event): void {
    this.mobileTopbarActive = !this.mobileTopbarActive;
    event.preventDefault();
  }
  checkQueryParam() {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.contentOnly = queryParams.contentOnly === 'true';
    if (this.contentOnly) {
      this.closeSideBar();
    }
  }
  onRightMenuButtonClick(event): void {
    this.rightMenuActive = !this.rightMenuActive;
    event.preventDefault();
  }

  onMenuClick(): void {
    this.menuClick = true;

    if (
      this.inlineMenuActive[this.currentInlineMenuKey] &&
      !this.inlineMenuClick
    ) {
      this.inlineMenuActive[this.currentInlineMenuKey] = false;
    }
  }

  onSearchKeydown(event): void {
    if (event.keyCode === 27) {
      this.search = false;
    }
  }

  onInlineMenuClick(event, key): void {
    if (key !== this.currentInlineMenuKey) {
      this.inlineMenuActive[this.currentInlineMenuKey] = false;
    }

    this.inlineMenuActive[key] = !this.inlineMenuActive[key];
    this.currentInlineMenuKey = key;
    this.inlineMenuClick = true;
  }

  onTopbarItemClick(event, item): void {
    this.topbarItemClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    if (item === 'search') {
      this.search = !this.search;
      this.searchClick = !this.searchClick;
    }

    event.preventDefault();
  }

  onTopbarSubItemClick(event): void {
    event.preventDefault();
  }

  onConfigClick(): void {
    this.configClick = true;
  }

  isDesktop(): boolean {
    return window.innerWidth > 991;
  }

  isMobile(): boolean {
    return window.innerWidth <= 991;
  }

  isOverlay(): boolean {
    return this.menuMode === MenuMode.Overlay;
  }

  isStatic(): boolean {
    return this.menuMode === MenuMode.Static;
  }
  isHorizontal(): boolean {
    return this.menuMode === MenuMode.Horizontal;
  }

  isSlim(): boolean {
    return this.menuMode === MenuMode.Slim;
  }
  isIcons(): boolean {
    return this.menuMode === MenuMode.Icons;
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(
        new RegExp(
          '(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)',
          'gi',
        ),
        ' ',
      );
    }
  }

  _subscribeToViewSideBarMode() {
    this.getSidebarConfig()
      .pipe(takeUntil(this.destroy$))
      .subscribe((visibility) => {
        this.toggleSideBar(visibility);
      });
  }

  closeSideBar() {
    this.menuActive = false;
    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = false;
    } else {
      this.mobileMenuActive = false;
      this.blockBodyScroll();
    }
  }

  openSideBar() {
    this.menuActive = true;
    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = true;
    } else {
      this.mobileMenuActive = true;
      this.blockBodyScroll();
    }
  }

  toggleSideBar(visibility: SidebarVisibility) {
    switch (visibility) {
      case SidebarVisibility.Close:
        this.closeSideBar();
        break;
      case SidebarVisibility.Open:
        this.openSideBar();
        break;
      default:
        break;
    }
  }

  override ngOnDestroy(): void {
    if (this.documentClickListener) {
      this.documentClickListener();
    }
    super.ngOnDestroy();
  }

  getSidebarConfig(): Observable<any> {
    return this.store.select(UserPreferencesState.sidebarVisibility);
  }
}
